module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_118-232cb1cc2a1a8ade9408e47c164c5ecf.png";